<template>
	<router-view v-slot="{ Component }">
		<transition name="fade" mode="out-in">
			<component :is="Component" />
		</transition>
	</router-view>
</template>

<script>
import Loader from "./blocks/Loader.vue";

export default {
	components: {
		Loader
	}
}
</script>